var CookiesFooterEnum = /* @__PURE__ */ ((CookiesFooterEnum2) => {
  CookiesFooterEnum2["COOKIES_FOOTER_TEXT"] = "cookies-footer-text";
  CookiesFooterEnum2["COOKIES_FOOTER_BUTTON"] = "cookies-footer-button";
  return CookiesFooterEnum2;
})(CookiesFooterEnum || {});
export {
  CookiesFooterEnum
};
